export class ChangeSlot {
    change(vb, slotAttachMap) {
        let map = slotAttachMap.get(this.slotId);
        let attachmentParse = map.get(this.attachment);
        if (attachmentParse) {
            vb.appendVB(attachmentParse);
        }
        else {
            attachmentParse = map.get(null);
        }
        this.attachmentParse = attachmentParse;
        return !this.attachmentParse.isClip;
    }
    changeOrder(attachMap) {
        attachMap[this.slotId] = this.attachmentParse;
        return null;
    }
}
